const alwaysDoubleDigits = (n: number) => (n < 10 ? `0${n}` : `${n}`);

export default function formatDuration(duration: number): string {
    const total = Math.ceil(duration);
    const minutes = Math.floor(total / 60);
    const seconds = total - minutes * 60;
    if (Number.isNaN(minutes) || Number.isNaN(seconds)) {
        return "00:00";
    }
    return `${alwaysDoubleDigits(minutes)}:${alwaysDoubleDigits(seconds)}`;
}
